import React from "react";
import { PaymentFrequency } from "../../../../../common/interfaces/enums/PaymentFrequency";
import { IClient } from "../../../../../common/interfaces/IClient";
import IQuoteCardResult from "../../../../interfaces/results/IQuoteCardResult";
import QuoteTableState from "../../../../types/quoteTable/IQuoteTableState";
import QuoteTableOverviewCard from "./QuoteTableOverviewCard";
import styles from "./QuoteTableOverview.module.scss";
import { QuoteTableView } from "../../../../enums/QuoteTableView";
import SortBy from "../../../../enums/SortBy";
import { getSortByAsString } from "../../../../../common/shared/enumHelpers";
import cx from "classnames";

import { QuoteTableCallToActionFunction } from "../../../../hooks/useQuoteSections";
import QuoteTableRightFitCard from "../RightFitCard/QuoteTableRightFitCard";

interface IQuoteTableOverviewProps {
    groupId: string;
    results: {
        quoteState: QuoteTableState;
        result: IQuoteCardResult;
    }[];
    clients: IClient[];
    sortBy: SortBy;
    handleCallToAction: QuoteTableCallToActionFunction;
    handlePaymentFrequencyChange: (newPaymentFrequency: PaymentFrequency) => void;
    setView: (newView: QuoteTableView) => void;
    className?: string;
    isDisabled?: boolean;
}

const QuoteTableOverview: React.FC<IQuoteTableOverviewProps> = (props) => {
    const {
        groupId,
        results,
        clients,
        sortBy,
        handleCallToAction,
        handlePaymentFrequencyChange,
        setView,
        className
        // isDisabled
    } = props;

    return (
        <div
            className={cx([
                styles["basic-container"],
                {
                    [className]: !!className
                }
            ])}>
            {results.map(({ result, quoteState }) => {
                return (
                    <QuoteTableOverviewCard
                        key={
                            result.result.providerId +
                            "-" +
                            Object.values(result.productInfo)
                                .map((s) => s.productId)
                                .join(";")
                        }
                        groupId={groupId}
                        card={result}
                        clients={clients}
                        bannerHeadingText={
                            quoteState.isHighlighted && getSortByAsString(sortBy)
                        }
                        quoteState={quoteState}
                        handlePaymentFrequencyChange={handlePaymentFrequencyChange}
                        handleCallToAction={handleCallToAction}
                        setView={setView}
                    />
                );
            })}
            <QuoteTableRightFitCard
                className={cx(
                    "layout-hidden-mobile",
                    "panel-quote-card-transparent",
                    "padding-xl"
                )}
            />
        </div>
    );
};

export default QuoteTableOverview;
